// extracted by css-extract-rspack-plugin
export default {"container":"LoadingState-module__container__LGb50"};